import React, { useState } from "react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";
import { contactInfo } from "../data/mockData";
import { openWhatsApp } from "../lib/whatsapp";

const ContactSection = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    const fullName = `${firstName} ${lastName}`.trim();
    const lines = [
      `Nombre: ${fullName || "No informado"}`,
      `Email: ${email || "No informado"}`,
      `Asunto: ${subject || "Consulta"}`,
      `Mensaje: ${message || "-"}`
    ];
    const whatsappMessage = `Hola, quiero hacer una consulta.\n${lines.join("\n")}`;
    openWhatsApp(whatsappMessage);
  };

  return (
    <section id="contacto" className="py-32">
      <div className="container mx-auto px-4">
        <div className="mx-auto flex max-w-screen-xl flex-col justify-between gap-10 lg:flex-row lg:gap-20">
          <div className="mx-auto flex max-w-sm flex-col justify-between gap-10">
            <div className="text-center lg:text-left">
              <h1 className="mb-2 text-4xl font-semibold lg:mb-1 lg:text-5xl">
                Contáctanos
              </h1>
              <p className="text-muted-foreground">
                Estamos disponibles para consultas, feedback o asesoramiento técnico.
              </p>
            </div>
            <div className="mx-auto w-fit lg:mx-0">
              <h3 className="mb-6 text-center text-2xl font-semibold lg:text-left">
                Datos de contacto
              </h3>
              <ul className="ml-4 list-disc space-y-2 text-sm">
                <li>
                  <span className="font-bold">Teléfono: </span>
                  {contactInfo.phone}
                </li>
                <li>
                  <span className="font-bold">Email: </span>
                  <a href={`mailto:${contactInfo.email}`} className="underline">
                    {contactInfo.email}
                  </a>
                </li>
                <li>
                  <span className="font-bold">Web: </span>
                  <a href="https://rgserviciotecnico.com" target="_blank" rel="noreferrer" className="underline">
                    rgserviciotecnico.com
                  </a>
                </li>
                <li>
                  <span className="font-bold">Horarios: </span>
                  {contactInfo.hours}
                </li>
              </ul>
            </div>
          </div>
          <div className="mx-auto flex w-full max-w-screen-md flex-col gap-6 rounded-lg border p-8">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="flex flex-col gap-4 sm:flex-row">
                <div className="grid w-full items-center gap-1.5">
                  <Label htmlFor="firstname">Nombre</Label>
                  <Input
                    type="text"
                    id="firstname"
                    placeholder="Nombre"
                    value={firstName}
                    onChange={(event) => setFirstName(event.target.value)}
                  />
                </div>
                <div className="grid w-full items-center gap-1.5">
                  <Label htmlFor="lastname">Apellido</Label>
                  <Input
                    type="text"
                    id="lastname"
                    placeholder="Apellido"
                    value={lastName}
                    onChange={(event) => setLastName(event.target.value)}
                  />
                </div>
              </div>
              <div className="grid w-full items-center gap-1.5">
                <Label htmlFor="email">Email</Label>
                <Input
                  type="email"
                  id="email"
                  placeholder="tu@email.com"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                />
              </div>
              <div className="grid w-full items-center gap-1.5">
                <Label htmlFor="subject">Asunto</Label>
                <Input
                  type="text"
                  id="subject"
                  placeholder="Consulta"
                  value={subject}
                  onChange={(event) => setSubject(event.target.value)}
                />
              </div>
              <div className="grid w-full gap-1.5">
                <Label htmlFor="message">Mensaje</Label>
                <Textarea
                  placeholder="Contanos tu consulta."
                  id="message"
                  rows={5}
                  value={message}
                  onChange={(event) => setMessage(event.target.value)}
                />
              </div>
              <Button className="w-full" type="submit">
                Enviar mensaje por WhatsApp
              </Button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
